var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportProblem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2906_11197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99991 3.35999C8.49991 3.35999 8.08991 3.76999 8.08991 4.26999L8.26991 11.01C8.26991 11.41 8.59991 11.74 8.99991 11.74C9.39991 11.74 9.72991 11.41 9.72991 11.01L9.90991 4.26999C9.90991 3.76999 9.49991 3.35999 8.99991 3.35999ZM8.99991 12.46C8.39991 12.46 7.90991 12.95 7.90991 13.55C7.90991 14.15 8.39991 14.64 8.99991 14.64C9.59991 14.64 10.0899 14.15 10.0899 13.55C10.0899 12.95 9.59991 12.46 8.99991 12.46Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.33 18H6.66999C5.76999 18 4.91999 17.65 4.27999 17.01L0.97999 13.71C0.33999 13.07 -0.0100098 12.22 -0.0100098 11.32V6.66C-0.0100098 5.76 0.33999 4.91 0.97999 4.27L4.27999 0.99C4.91999 0.35 5.76999 0 6.66999 0H11.33C12.22 0 13.09 0.36 13.72 0.99L17.02 4.29C17.65 4.92 18.01 5.79 18.01 6.68V11.34C18.01 12.24 17.66 13.09 17.02 13.73L13.72 17.03C13.08 17.67 12.24 18.02 11.33 18.02V18ZM6.66999 1.12C6.06999 1.12 5.49999 1.35 5.07999 1.78L1.77999 5.07C1.35999 5.49 1.11999 6.06 1.11999 6.66V11.32C1.11999 11.92 1.34999 12.49 1.77999 12.91L5.06999 16.21C5.49999 16.63 6.05999 16.87 6.65999 16.87H11.32C11.92 16.87 12.49 16.64 12.91 16.21L16.21 12.91C16.63 12.48 16.87 11.92 16.87 11.32V6.66C16.87 6.07 16.63 5.49 16.21 5.07L12.91 1.77C12.49 1.35 11.91 1.11 11.32 1.11H6.65999L6.66999 1.12Z",
    fill: "#616161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2906_11197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportProblem);
export default __webpack_public_path__ + "static/media/reportProblem.10e8fdd12370164d372cc7c501fed23f.svg";
export { ForwardRef as ReactComponent };